<div class="form-time">
  @if (label()) {
    <label [for]="id()" class="form-time__label">
      {{ label() | translate }}
      @if (control().hasValidator('required')) {
        <span class="form-time__required" aria-label="required">*</span>
      }
    </label>
  }
  
  <input
    #timeInput
    [id]="id()"
    type="time"
    [formControl]="control()"
    [readonly]="readonly()"
    [attr.aria-invalid]="shouldShowError"
    [attr.aria-describedby]="shouldShowError ? id() + '-error' : null"
    class="form-time__field"
    [class.form-time__field--error]="shouldShowError"
    (keydown)="onKeydownPicker($event, timeInput)"
  />
  
  @if (shouldShowError) {
    <div 
      [id]="id() + '-error'" 
      role="alert"
      aria-live="polite"
    >
      <app-validation-message [control]="control()" />
    </div>
  }
</div>
